enum CompetitiveInsightsCountyFilterTypeEnum {
  Current = "Current",
  Opportunity = "Opportunity",
}

export { CompetitiveInsightsCountyFilterTypeEnum };
